import React from 'react';
import PropTypes from 'prop-types';

const ConfigAssistantListGroup = props => {
  const { header, icon, children } = props;
  return (
    <div className="config-assistant-body-type">
      <div className="config-assistant-body-type__header">
        {icon}
        {header}
      </div>
      <div>{children}</div>
    </div>
  );
};

ConfigAssistantListGroup.propTypes = {
  header: PropTypes.node.isRequired,
  icon: PropTypes.node
};

export default ConfigAssistantListGroup;
